const PIM = "https://ofn.gov.cz/slovník/pim/";
export const HAS_TECHNICAL_LABEL = PIM + "technicalLabel";
export const HAS_INTERPRETATION = PIM + "hasInterpretation";
export const HAS_CLASS = PIM + "hasClass";
export const HAS_DATA_TYPE = PIM + "hasDatatype";
export const HAS_END = PIM + "hasEnd";
export const HAS_PARTICIPANT = PIM + "hasParticipant";
export const CLASS = PIM + "Class";
export const ATTRIBUTE = PIM + "Attribute";
export const ASSOCIATION = PIM + "Association";
export const ASSOCIATION_END = PIM + "AssociationEnd";
export const SCHEMA = PIM + "Schema";
export const HAS_ISA = PIM + "isa";
const DCTERMS = "http://purl.org/dc/terms/";
export const HAS_PART = DCTERMS + "hasPart";
export const HAS_HUMAN_LABEL = DCTERMS + "title";
export const HAS_HUMAN_DESCRIPTION = DCTERMS + "description";
export const CREATE_ASSOCIATION = PIM + "CreateAssociation";
export const CREATE_ASSOCIATION_RESULT = PIM + "CreateAssociationResult";
export const CREATE_ATTRIBUTE = PIM + "CreateAttribute";
export const CREATE_ATTRIBUTE_RESULT = PIM + "CreateAttributeResult";
export const CREATE_CLASS = PIM + "CreateClass";
export const CREATE_CLASS_RESULT = PIM + "CreateClassResult";
export const CREATE_SCHEMA = PIM + "CreateSchema";
export const CREATE_SCHEMA_RESULT = PIM + "CreateSchemaResult";
export const DELETE_ASSOCIATION = PIM + "DeleteAssociation";
export const DELETE_ATTRIBUTE = PIM + "DeleteAttribute";
export const DELETE_CLASS = PIM + "DeleteClass";
export const SET_CLASS_CODELIST = PIM + "SetClassCodelist";
export const SET_DATATYPE = PIM + "SetDataType";
export const SET_EXAMPLE = PIM + "SetExample";
export const SET_CARDINALITY = PIM + "SetCardinality";
export const SET_EXTENDS = PIM + "SetExtends";
export const SET_HUMAN_DESCRIPTION = PIM + "SetHumanDescription";
export const SET_HUMAN_LABEL = PIM + "SetHumanLabel";
export const SET_OBJECT_EXAMPLE = PIM + "SetObjectExample";
export const SET_REGEX = PIM + "SetRegex";
export const SET_TECHNICAL_LABEL = PIM + "SetTechnicalLabel";
//# sourceMappingURL=pim-vocabulary.js.map